"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lights = void 0;
const three_1 = require("three");
const KeyValList_1 = require("../../KeyValList");
class Lights {
    constructor(webgl) {
        this.lightsKeyValList = new KeyValList_1.KeyValList();
        this.isLightHelperVisible = false;
        this.lightHelpers = [];
        this.webgl = webgl;
    }
    add(lightType, id = null, makeVisible = false) {
        var _a, _b;
        const [light, lightHelper] = this.createLight(lightType);
        if (light && lightHelper) {
            (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.addObject(light);
            (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.addObject(lightHelper, true);
            // TODO: how to fix this, maybe event???
            // if (id === null) { this.changeSelected(light); }
            this.lightsKeyValList.add(id, light.uuid);
            this.lightHelpers.push(lightHelper);
            if (makeVisible) {
                lightHelper.visible = true;
            }
        }
        return light;
    }
    removeByUuid(uuid) {
        var _a;
        const light = (_a = this.lightHelpers.find(lh => lh.light.uuid === uuid)) === null || _a === void 0 ? void 0 : _a.light;
        if (!light) {
            return;
        }
        this.remove(light);
    }
    createLight(lightType) {
        let light;
        let lightHelper;
        const primaryColor = 0x0d6efd;
        const secondaryColor = 0x6c757d;
        const infoColor = 0x0dcaf0;
        switch (lightType) {
            case "DIRECTIONAL" /* DIRECTIONAL */:
                light = new three_1.DirectionalLight(primaryColor);
                lightHelper = new three_1.DirectionalLightHelper(light, 3, primaryColor);
                break;
            case "POINT" /* POINT */:
                light = new three_1.PointLight(secondaryColor);
                lightHelper = new three_1.PointLightHelper(light, 3, secondaryColor);
                break;
            case "SPOT" /* SPOT */:
                light = new three_1.SpotLight(infoColor);
                lightHelper = new three_1.SpotLightHelper(light, infoColor);
                break;
            default: throw new Error("Undefined light type");
        }
        if (light && lightHelper) {
            // Add light helper uuid to light user data, is needed later when removing light from scene
            light.userData = { lightHelperUuid: lightHelper.uuid };
            lightHelper.visible = this.isLightHelperVisible;
        }
        return [light, lightHelper];
    }
    selectLight(uuid) {
        var _a;
        if (!uuid) {
            return;
        }
        const light = (_a = this.lightHelpers.find(lh => lh.light.uuid === uuid)) === null || _a === void 0 ? void 0 : _a.light;
        if (!light) {
            return;
        }
        this.webgl.modelTransformService.attachObject(light);
        this.webgl.selected = light;
        // DO I EVEN NEED THIS?
        // PubSub.publish(PubSubEventType.OBJECT_INFO, light);
    }
    remove(light) {
        var _a, _b, _c, _d;
        const lightUuid = light.uuid;
        const lightHelperUuid = light.userData.lightHelperUuid;
        if (((_a = this.webgl.selected) === null || _a === void 0 ? void 0 : _a.uuid) === lightUuid) {
            this.webgl.modelTransformService.detachObject();
        }
        (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.removeObject(light);
        if (lightHelperUuid) {
            const lightHelper = (_c = this.webgl) === null || _c === void 0 ? void 0 : _c.scene.getObjectByProperty('uuid', lightHelperUuid);
            if (lightHelper) {
                (_d = this.webgl) === null || _d === void 0 ? void 0 : _d.removeObject(lightHelper);
            }
        }
        // Remove from lightHelpers
        const lightIndex = this.lightHelpers.findIndex(lh => lh.light.uuid === lightUuid);
        if (lightIndex > -1) {
            this.lightHelpers.splice(lightIndex, 1);
        }
        this.lightsKeyValList.removeByVal(lightUuid);
    }
    changeType(lightUuid, type) {
        var _a, _b;
        const [newLight, newLightHelper] = this.createLight(type);
        const oldLightHelperIndex = this.lightHelpers.findIndex(helper => helper.light.uuid === lightUuid);
        const oldLightHelper = this.lightHelpers[oldLightHelperIndex];
        const oldLight = oldLightHelper.light;
        if (!oldLightHelper) {
            return;
        }
        newLight.color.copy(oldLight.color);
        newLight.intensity = oldLight.intensity;
        newLight.position.copy(oldLight.position);
        newLight.rotation.copy(oldLight.rotation);
        newLight.scale.copy(oldLight.scale);
        // Removing old light
        this.webgl.modelTransformService.detachObject();
        this.remove(oldLight);
        // adding new one on the same index in array
        this.lightHelpers.splice(oldLightHelperIndex, 0, newLightHelper);
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.addObject(newLight);
        (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.addObject(newLightHelper, true);
        newLightHelper.visible = true;
        this.lightsKeyValList.add(null, newLight.uuid);
        // this.lightHelpers.push(newLightHelper);
        this.webgl.modelTransformService.attachObject(newLightHelper);
        this.webgl.selected = newLightHelper.light;
        return newLightHelper;
    }
}
exports.Lights = Lights;
